import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";

import { fretWidth, orientationIsFlipped } from "./lib";
import metaActions from "../../state/meta/actions";
import store from "../../store";

class FretboardFretHead extends PureComponent {
	static propTypes = {
		fret: PropTypes.number,
		orientation: PropTypes.string
	};

	onMouseOver = debounce(() => {
		store.dispatch(metaActions.update({ highlight: null }));
	}, 200, { leading: true, trailing: false })

	render() {
		let { fret, orientation = "ltr" } = this.props;
		let isFlipped = orientationIsFlipped(orientation);
		let scope = isFlipped ? "row" : "col";
		let length = isFlipped ? "height" : "width";
		let styles = {}, title = "";

		if (fret > 0) {
			styles = { [length]: `${fretWidth(fret)}em` };
			title = `Fret ${fret}`;
		}

		else {
			title = "Open string";
		}

		return (
			<th
				scope={scope}
				className={`frethead loc-0-${fret}`}
				style={styles}
				title={title}
				onMouseOver={this.onMouseOver}>
				{ fret }
			</th>
		);
	}
}

export default FretboardFretHead;
